import { FC, ReactNode } from "react";
import LandingSLiderTitle from "./SliderTitle";

interface Props {
  children: ReactNode;
  title?: string;
  viewAllLink?: string;
  swiperId?: string;
  isLoadingTitle?: boolean;
}

const CardsSliderLayout: FC<Props> = ({
  children,
  viewAllLink,
  title,
  swiperId = "",
  isLoadingTitle,
}) => {
  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 xsm:px-6 flex justify-center">
      <div className="flex flex-col max-w-[1232px] w-full festivalSwiper">
        <LandingSLiderTitle
          title={title}
          viewAllLink={viewAllLink}
          isLoadingTitle={isLoadingTitle}
        />
        <div className="relative w-full">
          <div className="w-full overflow-x-hidden">{children}</div>
          <div
            className={`bg-black hidden md:flex !opacity-100 disabled:bg-zinc-400 hover:text-white text-white rounded-full w-10 h-10 swiper-button-next left-0 md:left-[0.6vw] right-[unset] swiper-button-next-${swiperId} `}
          ></div>
          <div
            className={`bg-black hidden md:flex !opacity-100 disabled:bg-zinc-400 text-white hover:text-white rounded-full w-10 h-10 swiper-button-prev right-0 md:right-[0.2vw] left-[unset] swiper-button-disabled swiper-button-prev-${swiperId}`}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default CardsSliderLayout;
